import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/road.svg'
import _imports_1 from '@/assets/clock.svg'


const _withScopeId = n => (_pushScopeId("data-v-2e68dff3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "trip-container"
}
const _hoisted_2 = { class: "trip-item" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "distancia"
  })
], -1))
const _hoisted_4 = { class: "info" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Kms", -1))
const _hoisted_6 = { class: "trip-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "duration"
  })
], -1))
const _hoisted_8 = { class: "info" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Minutos", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.distance)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_ctx.distance) + " ", 1),
              _hoisted_5
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_ctx.duration) + " ", 1),
              _hoisted_9
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}